export const list = {
  table: {
    id: '順番',
    companyId: '納入先 CD',
    shortName: '顧客名(省略)',
    companyName: '顧客名',
    createdAt: '作成日',
  },
  buttonAction: {
    importAdd: 'インポート（追加）',
    importOverwrite: 'インポート（上書き）',
    export: 'エクスポート',
    update: 'アップデート',
  },
  pageHeader: {
    title: '顧客リスト　TOP',
    titleCustomersList: '個人データの登録/編集',
    new: '新規',
  },
}
